<dx-scroll-view #scrollView>
  <ng-content></ng-content>
</dx-scroll-view>
